module.exports = __webpack_public_path__ + "img/shareIcon-blue.a32ed0e3.svg";